import SubscriptionInfo from './subscription-info.vue';

export default SubscriptionInfo;
